import { fromPromise, type IPromiseBasedObservable } from "mobx-utils";

export function createInitialFromPromise<T>(initialValue: T) {
  return fromPromise.resolve<T>(initialValue) as IPromiseBasedObservable<T>;
}
